import React from "react"
import { Link } from "react-router-dom"
import { FaArrowLeft } from "react-icons/fa"

import classes from "./index.module.scss"

const PageNotFound = () => (
  <div className={classes["contianer"]}>
    <h2 className={classes["text"]}>
      خطا 404
    </h2>
    <h3 className={classes["text"]}>
      صفحه یافت نشد
    </h3>
    <Link to="/">
      <button
        className={classes["button"]}
      >
        <FaArrowLeft size={12} />{" "}
        بازگشت به خانه
      </button>
    </Link>
  </div>
)

export default PageNotFound